import axios from "axios";

const BASE_API = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

// class XLResponse{
//     constructor(code,data,msg){
//         this.code = code;
//         this.data = data;
//         this.msg = msg;
//     }

//     success(){
//         return this.code == CODE_SUCCESS
//     }
// }

import { ElMessage } from "element-plus";

let http = axios.create({
  baseURL: BASE_API,
  timeout: 9000,
  headers: {
    token: localStorage.getItem("token"),
    // 'Content-Type':'application/json'
  },
});
import router from "./../router";
import RES_CODE from "./code";

function needLogin() {
  localStorage.removeItem("token");
  router.push({
    name: "login",
  });
}

export function saveToken(token) {
  localStorage.setItem("token", token);
  http.defaults.headers["token"] = token;
}

export function APIPOST(url, data) {
  return new Promise((resolve, reject) => {
    http
      .post(url, data)
      .then((res) => {
        let data = res.data;
        if (data.code == RES_CODE.NEED_LOGIN) {
          needLogin();
        } else if (
          data.code > RES_CODE.ERROR_MIN &&
          data.code < RES_CODE.ERROR_MAX
        ) {
          resolve(data);
          return;
        } else if (data.code != RES_CODE.SUCCESS) {
          ElMessage.error(data.msg);
        }
        // const xl_res = new XLResponse(data.code,data.data,data.message)
        resolve(data);
      })
      .catch(() => {
        ElMessage.error("服务器内部出错！");
        reject("服务器内部出错！");
      });
  });
}
export function APIGET(url, data) {
  return new Promise((resolve, reject) => {
    http
      .get(url, { params: data })
      .then((res) => {
        let data = res.data;
        if (data.code == RES_CODE.NEED_LOGIN) {
          needLogin();
        } else if (data.code != RES_CODE.SUCCESS) {
          ElMessage.error(data.msg);
        }
        resolve(data);
      })
      .catch((error) => {
        ElMessage.error("服务器内部出错！");
        console.log("请求错误：", error);
        reject("服务器内部出错！");
      });
  });
}

export function APIUPLoad(url, file) {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("file", file);

    const defaultConfig = {
      headers: {
        "Content-Type": "multipart/form-data", // 设置请求头为 multipart/form-data
      },
    };
    http
      .post(url, formData, defaultConfig)
      .then((res) => {
        let data = res.data;
        if (data.code == RES_CODE.NEED_LOGIN) {
          needLogin();
        } else if (data.code != RES_CODE.SUCCESS) {
          ElMessage.error(data.msg);
        }
        // const xl_res = new XLResponse(data.code,data.data,data.message)
        resolve(data);
      })
      .catch(() => {
        ElMessage.error("服务器内部出错！");
        reject("服务器内部出错！");
      });
  });
}

/** 获取 本地 文件 */
export function APIPUBLIC(url, data) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, data)
      .then((res) => {
        let data = res.data;
        resolve(data);
      })
      .catch(() => {
        reject("服务器内部出错！");
      });
  });
}
